import React from 'react';
import PropTypes from 'prop-types';
import Pagination from './Pagination';
import SortBy from './SortBy';
import { SortAndPaginationWrapper } from './SortAndPagination.css';

const SortAndPagination = ({
  handleSortChange,
  s3BasePath,
  currentSorting,
  handleOffsetChange,
  paginationOffset,
  totalProducts,
}) => (
  <SortAndPaginationWrapper>
    <Pagination handleClick={handleOffsetChange} totalProducts={totalProducts} paginationOffset={paginationOffset} />
    <SortBy handleClick={handleSortChange} s3BasePath={s3BasePath} sortFilterSelect={currentSorting} />
  </SortAndPaginationWrapper>
);

SortAndPagination.propTypes = {
  handleOffsetChange: PropTypes.func.isRequired,
  paginationOffset: PropTypes.number.isRequired,
  totalProducts: PropTypes.number.isRequired,
  handleSortChange: PropTypes.func.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  currentSorting: PropTypes.string.isRequired,
};

export default SortAndPagination;
